var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress } from "@mui/joy";
export function LoaderImage() {
    return (_jsx("div", __assign({ className: "absolute inset-0 flex items-center justify-center bg-gray-200/70 backdrop-blur-sm z-[101]" }, { children: _jsx(CircularProgress, { variant: "soft", color: "primary" }) })));
}
